exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#AssignUserToGroup .v--modal-box.v--modal{min-height:350px!important;min-width:500px!important}#AssignUserToGroup .v-input__slot,#AssignUserToGroup .v-select__slot label,#AssignUserToGroup .v-text-field__slot label{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bcdfeb2e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/userManagement/AssignUserGroup.vue
// module id = 1973
// module chunks = 0